import Image from "next/image";
import Link from "next/link";

export default function Logo() {
  return (
    <Link href={"/"} className="flex items-center gap-1">
      <Image
        priority
        className="size-[33px] max-sm:size-[42px]"
        src={"/logoBill.svg"}
        alt="believe-in logo"
        width={50}
        height={50}
        quality={100}
      />
      <h2 className="text-white text-[18px] font-[500] tracking-wide max-sm:hidden">
        BELIEVE IN.FUN
      </h2>
    </Link>
  );
}
